import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "src/environments/environment";
import {Storage} from '@ionic/storage';

@Injectable({
    providedIn: 'root'
})
export class MyContributionService {
    _headers: HttpHeaders;

    constructor(
        private http: HttpClient,
        private storage: Storage
    ) {
        this._headers = new HttpHeaders();
        this._headers = this._headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    }

    getGivingType(body) {
        let api = environment.api_end_point + '/givings/givingtype';
        return this.http.post(api, JSON.parse(body), {headers: this._headers});
    }

    getPaymentDetails(body) {
        let api = environment.api_end_point + '/givings/get_donorsources';
        return this.http.post(api, JSON.parse(body), {headers: this._headers});
    }

    getEpicPayTemplate(body) {
        let api = environment.api_end_point + '/givings/get_eptpl';
        return this.http.post(api, JSON.parse(body), {headers: this._headers});
    }

    removePaymentSource(body) {
        let api = environment.api_end_point + '/givings/delete_source';
        return this.http.post(api, JSON.parse(body), {headers: this._headers});
    }

    makePayment(body: any, is_guest){
        let api;
        if (is_guest === false) {
            api = environment.api_end_point + '/givings/process_payment';
        }
        else if (is_guest === true){
            api = environment.api_end_point + '/givings/process_payment_guest';
        }

        return this.http.post(api, JSON.parse(body), {headers: this._headers});
    }

    createPledge(body) {
        let api = environment.api_end_point + '/givings/createpledge';
        return this.http.post(api, JSON.parse(body), {headers: this._headers});
    }

    createPledge_guest(body) {
        let api = environment.api_end_point + '/givings/guestcreatepledge';
        return this.http.post(api, JSON.parse(body), {headers: this._headers});
    }

    checkCaptcha(token) {
        let api = environment.api_end_point + '/givings/checkCaptcha/' + token+'/1';
        return this.http.get(api);
    }
}
